import React from "react";


const EPassetshealth = () => {
  document.title = "ep-assets-health";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>ep-assets-health</h1>
        
      </div>
    </React.Fragment>
  );
};

export default EPassetshealth;
